function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBridge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.1868 12.219C4.58448 4.82942 15.4138 4.82869 17.8132 12.2168V10.3143C17.8132 9.98827 18.0789 9.72398 18.4066 9.72398C18.7343 9.72398 19 9.98827 19 10.3143V15.0859C19 15.412 18.7343 15.6763 18.4066 15.6763C18.0789 15.6763 17.8132 15.412 17.8132 15.0859V13.9074C17.746 13.9391 17.6706 13.957 17.5904 13.957H2.4103C2.32979 13.957 2.25414 13.9389 2.1868 13.907L2.1868 15.0859C2.1868 15.412 1.92113 15.6763 1.5934 15.6763C1.26567 15.6763 1 15.412 1 15.0859V10.3143C1 9.98827 1.26567 9.72398 1.5934 9.72398C1.92113 9.72398 2.1868 9.98827 2.1868 10.3143L2.1868 12.219ZM7.9232 8.09371V12.8272H6.143L6.143 8.87591C6.69898 8.53273 7.29952 8.272 7.9232 8.09371ZM3.1893 12.8272H4.95619L4.95619 9.80687C4.1665 10.5862 3.54483 11.5929 3.1893 12.8272ZM9.11 12.8272L9.11 7.85655C9.7009 7.78718 10.3001 7.78718 10.891 7.85655V12.8272H9.11ZM12.0778 8.09371L12.0778 12.8272H13.858V8.87591C13.302 8.53273 12.7015 8.272 12.0778 8.09371ZM16.8117 12.8272H15.0448V9.80687C15.8345 10.5862 16.4561 11.5929 16.8117 12.8272Z",
    style: {
      fill: "var(--icon-color, currentColor)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBridge);
export default __webpack_public_path__ + "static/media/icon-bridge.b843f48ab8c96678a357447d9c331e29.svg";
export { ForwardRef as ReactComponent };